import { objectToQueryString } from 'smart-react';
import { apiCall } from '../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from "../../../Utils/Auth/AuthToken";

const routeName = '/users';

/**
 * Lists Users.
 * @returns {Promise} - A promise that resolves with the list of users or rejects with an error.
 * @param props
 */
export const listUsers = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  let parameters = objectToQueryString({ offset, limit }); // Simplified object property names
  const response = await userApiCall({
    url: `${routeName}?${parameters}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return { users: response.payload.data, TotalCount: response?.totalCount };
};

/**
 * Add User.
 * @param {object} data - An object of User data to add
 * @returns {Promise} - A promise that resolves with the update user api or rejects with an error.
 */
export const addUser = async (data) => {
  let response = await userApiCall({
    url: `${routeName}`,
    method: 'POST',
    data,
  });
  return response;
};

/**
 * Update User.
 * @param {object} data - An object of User data to update
 * @returns {Promise} - A promise that resolves with the update user api or rejects with an error.
 */
export const updateUser = async (data) => {
  let response = await userApiCall({
    url: `${routeName}/${data.id}`,
    method: 'PUT',
    data,
  });
  return response;
};

/**
 * Delete User.
 * @param {number} id - User ID to delete the record.
 * @returns {Promise} - A promise that resolves with the delete user api or rejects with an error.
 */
export const deleteUser = async (id) => {
  let response = await userApiCall({
    url: `${routeName}/${id}`,
    method: 'DELETE',
  });
  return response;
};

/**
 * Get User Details.
 */
export const getUser = async (id) => {
  const { accessToken } = getTokensFromStorage();
  let response = await userApiCall({
    url: `/user`,
    method: 'GET',
    accessToken,
  });
  return response;
};

/**
 * Update Account.
 * @param {object} data - An object of User data to update
 * @returns {Promise} - A promise that resolves with the update user api or rejects with an error.
 */
export const updateAccount = async (data) => {
  const { accessToken } = getTokensFromStorage();
  let response = await userApiCall({
    url: `/user/profile`,
    method: 'POST',
    body: JSON.stringify(data),
    accessToken,
  });
  return response;
};

/**
 * User Api Call Wrapper Method.
 * @param {object} api - Contains details like url headers method and data.
 * @returns {Promise} - A promise that resolves with the data of user or rejects with an error.
 */
const userApiCall = async (request) => {
  let response;

  try {
    response = await apiCall(request);
  } catch (e) {
    response = { isSuccess: false, message: e.message };
  }
  return response;
};
